module.exports = __webpack_public_path__ + "static/media/user.779f5049.svg";